import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import CalculatorIcon from '@icons/custom/calculator.svg';
import { SvgIconComponent } from '@web/shared/components/svg-icon/svg-icon.component';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-metric-computation-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, RouterLink, NgTemplateOutlet, SvgIconComponent],
  template: `
    @let _metricComputation = metricComputation();
    @let _clickable = clickable();
    @let _size = size();

    @if (_clickable) {
      <a
        [routerLink]="[
          '/',
          'biddings',
          'bids',
          _metricComputation.bid.id,
          'metric-computations',
          _metricComputation.id,
        ]"
        (click)="onClick($event)"
        class="h-fit w-fit leading-0 flex"
      >
        <ng-container [ngTemplateOutlet]="tag" />
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="tag" />
    }

    <ng-template #tag>
      @let _small = _size === 'small';
      <p-tag [class]="{ 'h-6': !_small, 'w-26': !_small, 'h-5': _small, 'w-20': _small }">
        <div class="flex items-center gap-1 px-1.5 whitespace-nowrap">
          <app-svg-icon [icon]="CalculatorIcon" [class]="_small ? 'size-2' : 'size-3'" />

          <span [class]="_size === 'small' ? '!text-2xs' : '!text-sm'" class="font-bold">
            {{ _metricComputation.code }}
          </span>
        </div>
      </p-tag>
    </ng-template>
  `,
  styles: [
    `
      .p-tag {
        border: 1px solid var(--color-soe-petrol-blue);
        box-shadow: 2px 1px 0px 0px var(--color-soe-petrol-blue);
        --p-tag-primary-background: var(--color-white);
        padding: 0;
        --p-tag-primary-color: var(--color-black);
      }
    `,
  ],
})
export class MetricComputationTagComponent {
  readonly size = input<'small' | 'default'>('default');
  readonly clickable = input<boolean>(false);
  readonly metricComputation = input.required<{ id: string; code: string; bid: { id: string } }>();

  readonly CalculatorIcon = CalculatorIcon;

  onClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
